import { css } from '@emotion/react';
import type { SerializedStyles, Theme } from '@emotion/react';

/**
 * These shared config items eliminate the need for non-performant calls to the theme.
 * This should help reduce the time it takes to calculate Emotion styles.
 * See this blog post for more: https://itnext.io/how-to-increase-css-in-js-performance-by-175x-f30ddeac6bce
 */

const config = {
  sizes: {
    down: {
      xs: 599,
      sm: 1060,
      md: 1439,
    },
    up: {
      xs: 0,
      sm: 600,
      md: 1061,
    },
  },
} as const;

export interface SearchTheme extends Theme {
  searchPageContainer: SerializedStyles;
  mainContent: SerializedStyles;
}

export function isSearchTheme(theme: Theme): theme is SearchTheme {
  return !!(theme as SearchTheme).searchPageContainer;
}

export const searchTheme = (theme: Theme): SearchTheme => ({
  ...theme,
  searchPageContainer: css`
    background-color: var(--cds-color-neutral-background-primary);
    overflow-x: hidden; /* mobile-friendly */
    overflow-y: hidden;

    .bt3-container.body-container {
      max-width: 100vw;
      margin: 0;
      padding: 0;
      width: 100%;

      @media screen and (max-width: ${config.sizes.down.sm}px) {
        padding-right: 0;
        padding-left: 0;
      }
    }

    @media screen and (max-width: ${config.sizes.down.sm}px) {
      .mobile-search-page-bar {
        width: 100%;

        .rc-SearchBar {
          width: 100%;
          margin: 0;

          .rc-AutoComplete {
            width: 100%;
          }
        }
      }
    }

    hr {
      width: 100%;
    }

    /* enterprise only */
    .filter-menu-and-number-of-results {
      & > div:first-of-type {
        width: 100%;
      }
    }
  `,
  mainContent: css`
    background-color: var(--cds-color-grey-25);
    padding: 36px 0;
  `,
});
